import { ModificationPointType } from "../ui/ModificationPointType";
import { Labels } from "../constants/Labels";
import { ImageFormat, PixiImageFormat } from "../ui/ImageFormat";

export class Mapper {
  public static StringToModificationPointType(modificationPoint: string): ModificationPointType | undefined {
    switch (modificationPoint) {
      case Labels.TopLeftPoint:
        return ModificationPointType.TopLeft;
      case Labels.TopRightPoint:
        return ModificationPointType.TopRight;
      case Labels.BottomRightPoint:
        return ModificationPointType.BottomRight;
      case Labels.BottomLeftPoint:
        return ModificationPointType.BottomLeft;
      case Labels.ChamferEdgeLeft:
        return ModificationPointType.ChamferEdgeLeft;
      case Labels.ChamferEdgeRight:
        return ModificationPointType.ChamferEdgeRight;
      case Labels.ArchEdgeLeft:
        return ModificationPointType.ArchEdgeLeft;
      default:
        return undefined;
    }
  }

  public static ModificationPointTypeToString(modificationPointType: ModificationPointType): string | undefined {
    switch (modificationPointType) {
      case ModificationPointType.TopLeft:
        return Labels.TopLeftPoint;
      case ModificationPointType.TopRight:
        return Labels.TopRightPoint;
      case ModificationPointType.BottomRight:
        return Labels.BottomRightPoint;
      case ModificationPointType.BottomLeft:
        return Labels.BottomLeftPoint;
      case ModificationPointType.ChamferEdgeLeft:
        return Labels.ChamferEdgeLeft;
      case ModificationPointType.ChamferEdgeRight:
        return Labels.ChamferEdgeRight;
      case ModificationPointType.ArchEdgeLeft:
        return Labels.ArchEdgeLeft;
      default:
        return undefined;
    }
  }

  public static ImageFormatToString(imageFormat: ImageFormat): PixiImageFormat | undefined {
    switch (imageFormat) {
      case ImageFormat.PNG:
        return "png";
      case ImageFormat.JPG:
        return "jpg";
      case ImageFormat.WEBP:
        return "webp";
      default:
        return undefined;
    }
  }
}